import { TDestinationCredentials } from '@/core/apis/config_api/config_api_types';
import { TMableEvent } from '@/core/constants/event_types/base_mable_event';
import { EMableEventName } from '@/core/constants/event_types/events';
import { ServiceMetricsUtils } from '@/core/event_logic/utils/service_metrics_utils';
import { EDestinationType } from '@/core/interfaces';
import MableEventApi from '@/destinations/bundles/mable/mable_event_api';

import {
  DestinationBundle,
  DestinationPayload,
  DestinationSendingResult,
} from '../abstract';

// Example implementation of DestinationBundle for ExampleDestinationType
export class MableDestinationBundle extends DestinationBundle {
  override allowedEvents: EMableEventName[] = [
    EMableEventName.PAGE_VIEWED,
    EMableEventName.PRODUCT_ADDED,
    EMableEventName.CHECKOUT_STARTED,
    EMableEventName.PAYMENT_INFO_ADDED,
    EMableEventName.PRODUCT_VIEWED,
    EMableEventName.LEAD,
    EMableEventName.COLLECTION_VIEWED,
    EMableEventName.ORDER_COMPLETED,
    EMableEventName.CUSTOM_EVENT,
  ];
  constructor(
    destinationSetting: TDestinationCredentials,
    destinationId: string,
  ) {
    super(EDestinationType.Mable, destinationSetting, destinationId);
  }

  override async init(): Promise<void> {
    // Initialization logic for ExampleDestinationBundle
    // void super.init();
  }

  override calculatePayload(mableEvent: TMableEvent): DestinationPayload {
    return mableEvent;
  }

  override async sendToDestination(
    payload: TMableEvent,
  ): Promise<DestinationSendingResult> {
    // For tests compatibility, add service metric if not already present
    payload = await ServiceMetricsUtils.updateServiceMetricExitTime(
      payload,
      'mable_destination',
    );

    // Fire-and-forget pattern - don't await the worker
    // This will let the worker process the event in the background
    await MableEventApi.sendMableEvent({
      mableEvent: payload,
    });

    // Immediately return success since we've delegated to the worker
    return {
      destinationReqEvent: payload,
      reason: 'Payload sent to worker for background processing',
      success: true,
    };
  }
}
